export const ReceiptProviderTypes = {
  EKASSA: 2,
};

export const CONFIGURABLE_RECEIPT_PROVIDERS = [
  { typeId: ReceiptProviderTypes.EKASSA, name: 'eKassa', path: 'ekassa' },
];

export const EKASSA_TAXATION_SYSTEMS = [
  { id: 0, name: 'Общий налоговый режим' },
  { id: 1, name: 'Налог на основе обязательного патента' },
  { id: 2, name: 'Налог на основе добровольного патента' },
  { id: 3, name: 'Упрощенная система налогообложения на основе единого налога' },
  { id: 4, name: 'Налоги на основе налогового контракта' },
  { id: 5, name: 'Налоговый режим в свободных экономических зонах' },
  { id: 6, name: 'Налоговый режим в Парке высоких технологий' },
  { id: 7, name: 'Упрощенная система налогообложения на основе налога с розничных продаж' },
  { id: 8, name: 'Налог на майнинг' },
  { id: 9, name: 'Налог на деятельность в сфере электронной торговли' },
  { id: 10, name: 'Налог на игорную деятельность' },
  { id: 11, name: 'Упрощенная система налогообложения на основе единого налога (для ИП с 0%)' },
  { id: 12, name: 'Упрощенная система налогообложения на основе единого налога (для рынка 0,1%)' },
  { id: 13, name: 'Упрощенная система налогообложения на основе единого налога (до 30 – 0,5%)' },
  { id: 14, name: 'Упрощенная система налогообложения на основе единого налога (до 50 – 1%)' },
];
